const cdnjs = {
    "picturefill": "https://cdn.jsdelivr.net/npm/picturefill@3.0.3/dist/picturefill.min.js",
    "recaptcha": "https://www.google.com/recaptcha/api.js?render={apikey}",
    "seamless": "https://cdn.jsdelivr.net/npm/seamless-scroll-polyfill@2.1.5/lib/bundle.min.js",
    "parallax": "https://cdn.jsdelivr.net/npm/parallax-js@3.1.0/dist/parallax.min.js",
    "googlemaps": "https://maps.googleapis.com/maps/api/js?key={apikey}",
    "googlemaps_cluster": "https://cdn.jsdelivr.net/npm/@google/markerclustererplus@5.1.0/dist/markerclustererplus.min.js",
    "autosize": "https://cdn.jsdelivr.net/npm/autosize@4.0.2/dist/autosize.min.js"
};
